import { all, takeLatest } from 'redux-saga/effects';
import formatDate from 'date-fns/format';

import {
  fetchDailyReportsService,
  fetchMonthyReportsService,
  fetchYearlyReportsService,
} from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* reportsWatchers() {
  yield all([
    takeLatest(
      EntryActionTypes.DAILY_REPORTS_FETCH_REQUEST,
      ({ payload: { currentDay, interval } }) => fetchDailyReportsService(currentDay, interval),
    ),
    takeLatest(EntryActionTypes.MONTHLY_REPORTS_FETCH_REQUEST, ({ payload: { currentMonth } }) =>
      fetchMonthyReportsService(currentMonth),
    ),
    takeLatest(EntryActionTypes.YEARLY_REPORTS_FETCH_REQUEST, ({ payload: { currentYear } }) =>
      fetchYearlyReportsService(currentYear),
    ),
    takeLatest(EntryActionTypes.CURRENT_REPORTS_FETCH_REQUEST, () => {
      const currentDay = formatDate(new Date(), 'yyyyMMdd');
      const currentMonth = formatDate(new Date(), 'yyyyMM');
      const currentYear = formatDate(new Date(), 'yyyy');
      const interval = 60;
      fetchDailyReportsService(currentDay, interval);
      fetchMonthyReportsService(currentMonth);
      fetchYearlyReportsService(currentYear);
    }),
  ]);
}
